import { $tracing } from '../tracing';

export const ViewApiSecretPwdErrorTrack = (error: any) => {
  try {
    $tracing.addEvent({
      t: 'view api secret pwd error',
      ext: {
        error,
      },
    });
  } catch (error) {
    /* empty */
  }
};

export const EscrowInstitutionNotExist = (error: any) => {
  try {
    $tracing.addEvent({
      t: 'escrow not exist',
      ext: {
        error,
      },
    });
  } catch (error) {
    /* empty */
  }
};

export const ApiManagementListDataFail = (error: any) => {
  try {
    $tracing.addEvent({
      t: 'api management list fail',
      ext: {
        error,
      },
    });
  } catch (error) {
    /* empty */
  }
};

export const DeleteApiKeyEmptyRiskToken = (params: {
  subAccountId?: string;
  apiManagementId: string;
}) => {
  try {
    $tracing.addEvent({
      t: 'delete api key no risk token',
      ext: params,
    });
  } catch (error) {
    /* empty */
  }
};
